var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"items-per-page":-1,"loading":_vm.loading,"loading-text":'Chargement en cours...',"hide-default-footer":"","fixed-header":"","height":"800px","item-key":"_id","sort-by":"partType","multi-sort":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }